/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

Array.prototype.slice.call(document.querySelectorAll('[data-section-type="featured-collection"]')).forEach(row => {
	if (!row.querySelector('.collection-item')) {
		row.parentElement.removeChild(row);
	}
});

var Evolve = Evolve || {};

Evolve.clubTable = {
    init: function() {
        this.clubTableHead = document.querySelector('#club-table thead');
        if (!this.clubTableHead) {
            return;
        }
        this.bindEvents();
      	document.querySelector('#club-table th').click();
    },
    bindEvents: function() {
        this.handleTableHeadClick = this.handleTableHeadClick.bind(this);
        this.clubTableHead.addEventListener('click', this.handleTableHeadClick);
    },

    handleTableHeadClick: function(e) {
        e.preventDefault();
        var target = e.path.reduce(function(acc, el) {
            if (!acc) {
                acc = el.tagName === 'TH' ? el : acc;
            }
            return acc
        }, null);
        console.log(target);
        this.sortTableRows(target);
    },
    getSelectedIndex: function(target) {
        return Array.prototype.slice.call(document.querySelector('#club-table thead tr').children).indexOf(target)
    },
    clearTableRows: function(table) {
        table.querySelector('tbody').innerText = '';
    },
    insertTableRows: function(table, rows) {
        var tbody = table.querySelector('tbody')
        rows.forEach(function(r) {
            tbody.appendChild(r);
        })
    },
    getSortDirection: function(target) {
        return target.getAttribute('data-sort-direction');
    },
    setSortDirection: function(target, value) {
        Array.prototype.slice.call(document.querySelectorAll('[data-sort-direction]')).forEach(function(el) {
            el.removeAttribute('data-sort-direction')
        });
        return target.setAttribute('data-sort-direction', value);
    },
    reverseSortOrder: function(rows, direction, selectedIndex) {
        if (direction === 'ASC') {
            return this.sortRowsDesc(rows, selectedIndex);
        }
        return this.sortRowsAsc(rows, selectedIndex);
    },
    sortTableRows: function(target) {
        var clubTable = document.getElementById('club-table');
        if (!clubTable) {
            return;
        }
        var tableRows = Array.prototype.slice.call(clubTable.querySelectorAll('tbody tr'));
        if (tableRows.length === 0) {
            return;
        }
        var selectedIndex = this.getSelectedIndex(target);
        if (selectedIndex < 0) {
            return;
        }
        var sortDirection = this.getSortDirection(target);
        if (sortDirection) {
            tableRows = this.reverseSortOrder(tableRows, sortDirection, selectedIndex);
            this.setSortDirection(target, sortDirection === 'ASC' ? 'DESC' : 'ASC');
        } else {
            tableRows = this.sortRowsAsc(tableRows, selectedIndex);
            this.setSortDirection(target, 'ASC');
        }
        this.clearTableRows(clubTable);
        this.insertTableRows(clubTable, tableRows);
    },
    sortRowsAsc: function(rows, index) {
        var selector = index === 0 ? 'td' : 'td:nth-child(' + (index + 1) +')';
        console.log(selector)
        return rows.sort(function(a, b) {
            var aText = a.querySelector(selector).innerText.trim().toLowerCase();
            var bText = b.querySelector(selector).innerText.trim().toLowerCase();
            if (aText > bText) {
                return 1;
            }
            if (aText < bText) {
                return -1;
            }
            return 0;
        });
    },
    sortRowsDesc: function(rows, index) {
        var selector = index === 0 ? 'td' : 'td:nth-child(' + (index + 1) +')';
        console.log(selector)
        return rows.sort(function(a, b) {
            var aText = a.querySelector(selector).innerText.trim().toLowerCase();
            var bText = b.querySelector(selector).innerText.trim().toLowerCase();
            if (aText < bText) {
                return 1;
            }
            if (aText > bText) {
                return -1;
            }
            return 0;
        });
    }
}

window.addEventListener('DOMContentLoaded', function() {
	Evolve.clubTable.init();
});